/* unplugin-vue-components disabled */import { render } from "./input-controls.vue?vue&type=template&id=50334eb8&scoped=true"
import script from "./input-controls.vue?vue&type=script&lang=js"
export * from "./input-controls.vue?vue&type=script&lang=js"

import "./input-controls.vue?vue&type=style&index=0&id=50334eb8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50334eb8"],['__file',"src/components/chat-input-v2/input-controls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50334eb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50334eb8', __exports__)) {
    api.reload('50334eb8', __exports__)
  }
  
  module.hot.accept("./input-controls.vue?vue&type=template&id=50334eb8&scoped=true", () => {
    api.rerender('50334eb8', render)
  })

}


export default __exports__